import { FC } from 'react';
import { Link } from 'react-router';
import { Bell } from 'lucide-react';
import aakashLogo from '@/assets/images/shared/aakash-logo.svg';
import { ThemeToggle } from '@/core/shared/components/theme-toggle/ThemeToggle';

export const Navbar: FC = () => {
  return (
    <header 
      className="bg-layout border-b border-border fixed w-full z-50 transition-colors duration-300"
      data-testid="navbar"
    >
      <div 
        className="flex justify-between items-center h-[99px] pl-8 pr-10"
        data-testid="navbar-container"
      >
        {/* Logo Section */}
        <div 
          className="flex items-center"
          data-testid="logo-section"
        >
          <Link to="/get-started" data-testid="navbar-logo-link">
            <img 
              src={aakashLogo} 
              alt="Aakash" 
              data-testid="navbar-logo"
            />
          </Link>
        </div>

        {/* Action Buttons Section */}
        <div 
          className="flex items-center space-x-4"
          data-testid="action-buttons"
        >
          {/* Notifications Button */}
          <button
            className="relative p-2 rounded-full border border-[#B3B3B3] w-10 h-10 flex items-center justify-center hover:bg-overlay transition-colors duration-300"
            aria-label="Notifications"
            data-testid="notification-button"
          >
            <Bell 
              size={20} 
              className="text-text-secondary" 
              data-testid="bell-icon"
            />
            {/* <span 
              className="absolute top-1 right-1 w-2 h-2 bg-primary rounded-full"
              data-testid="notification-dot"
            ></span> */}
          </button>

          {/* Theme Toggle Button */}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
